<template>
    <div class="right_box_main">
        <div class="listBox-item">
            <!-- 面包屑 -->
            <!-- <div class="mianbao">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
                    <el-breadcrumb-item>考情管理</el-breadcrumb-item>
                    <el-breadcrumb-item>申请管理</el-breadcrumb-item>
                    <el-breadcrumb-item>请假管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div> -->
            <!-- 表格 -->
            <el-card class="publicCard">
                <!-- 搜索框 -->
                <div>
                    <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                        <el-form-item label="姓名" class="mb16">
                            <el-input v-model="searchlist.applyName" placeholder></el-input>
                        </el-form-item>
                        <el-form-item label="状态" prop="region" class="mb16">
                            <el-select v-model="searchlist.approvalStatus" placeholder="请选择">
                                <el-option label="未审批" value="0"></el-option>
                                <el-option label="审批已通过" value="2"></el-option>
                                <el-option label="审批未通过" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="日期" class="mb16">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item class="mb16">
                            <el-button type="primary" @click="searchlistdata">查询</el-button>
                        </el-form-item>
                        <el-form-item class="mb16">
                            <el-button type="info" @click="searchlistReset" >重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 表格主体 -->
                <div class="listBox-item">
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="applyName" label="姓名" :show-overflow-tooltip="true" width="100"></el-table-column>
                            <el-table-column align="center" prop="orgName" label="所属机构" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="applyType" label="请假类型" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{scope.row.applyType | applyTypeListFilter}}
                                    <!-- <span
                                        v-if="tableData[scope.$index].applyType==1"
                                    >事假</span>
                                    <span v-if="tableData[scope.$index].applyType==2">病假</span>
                                    <span v-if="tableData[scope.$index].applyType==3">调休</span>-->
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="startTime" label="开始时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="endTime" label="结束时间" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="leaveTimeLength" label="请假时长（小时)" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="approvalName" label="审批人" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column align="center" prop="approvalStatus" label="状态">
                                <template slot-scope="scope">
                                    <span v-if="tableData[scope.$index].approvalStatus==0">未审批</span>
                                    <span v-if="tableData[scope.$index].approvalStatus==1">审批未通过</span>
                                    <span v-if="tableData[scope.$index].approvalStatus==2">审批已通过</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop label="操作">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="审核"
                                        placement="top-start"
                                        :enterable="false"
                                    >
                                        <button
                                            @click="examineDialog(scope.row.id)"
                                            class="tabBtn iconfont icon-shenpi shenhe"
                                            v-if="scope.row.approvalStatus==0"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="查看"
                                        placement="top-start"
                                        :enterable="false"
                                    >
                                        <button
                                            @click="lookDialog(scope.row.id)"
                                            class="tabBtn iconfont icon-chakan shenhe"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="删除"
                                        placement="top-start"
                                        :enterable="false"
                                    >
                                        <button
                                            class="tabBtn el-icon-delete tabBtn-delete"
                                            @click="deleteDialog(scope.row.id)"
                                        ></button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                    </div>
                </div>
            </el-card>

            <!-- 审核对话框 -->
            <el-dialog title="审核" :visible.sync="examineDialogVisible" width="60%">
                <el-form ref="examineForm" :model="examine" label-width="140px" :rules="rules">
                    <el-form-item label="姓名:">
                        <el-input v-model="examine.applyName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="所属机构:">
                        <el-input v-model="examine.orgName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假类型:">
                        <el-input v-model="examine.applyType" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间:">
                        <el-input v-model="examine.startTime" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="结束时间:">
                        <el-input v-model="examine.endTime" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假时长（小时）:">
                        <el-input v-model="examine.leaveTimeLength" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假事由:">
                        <el-input v-model="examine.applyReason" type="textarea" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="图片:">
                        <img alt  v-for="(item,index) in examine.photo" :src="item" :key="index" class="tbImgTwo" @click='show(item)' />
                    </el-form-item>
                    <el-form-item label="审批人:">
                        <el-input v-model="examine.approvalName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-input v-model="examine.approvalStatus" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="审核意见:" style="margin-bottom:20px">
                        <p style='color:red;font-size:12px'>此项为审核不通过时必填项,审核通过可忽略此项 !</p>
                        <el-input v-model="examine.suggestion" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="shenhe(examine.id,'2')" type="primary">审核通过</el-button>
                        <el-button @click="shenhe(examine.id,'1')" type="info">审核不通过</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <!-- 查看对话框 -->
            <el-dialog title="查看" :visible.sync="lookDialogVisible" width="35%">
                <el-form ref="examineForm" :model="examine" label-width="140px" :rules="rules">
                    <el-form-item label="姓名:">
                        <el-input v-model="examine.applyName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="所属机构:">
                        <el-input v-model="examine.orgName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假类型:">
                        <el-input v-model="examine.applyType" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间:">
                        <el-input v-model="examine.startTime" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="结束时间:">
                        <el-input v-model="examine.endTime" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假时长（小时）:">
                        <el-input v-model="examine.leaveTimeLength" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="请假事由:">
                        <el-input v-model="examine.applyReason" type="textarea" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="图片:">
                        <img alt  v-for="(item,index) in examine.photo" :src="item" :key="index" class="tbImgTwo" @click='show(item)' />
                    </el-form-item>
                    <el-form-item label="审批人:">
                        <el-input v-model="examine.approvalName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-input v-model="examine.approvalStatus" disabled></el-input>
                    </el-form-item>
                </el-form>
            </el-dialog>


            <!-- 大图 -->
            <div v-if='showImg' @click='showImg = false' class="bigbox">
                <img :src="showImgUrl" class="bigImg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { post } from "@/api/requrestHttp";
// 表格数据和分页js
import { tabdata } from "@/mixins/tabledataMix.js";
// 表单校验js
// import { validatePhoneOrMobile } from "@/utils/validate.js";
export default {
    mixins: [tabdata],
    data() {
        return {
            showImg:false,
            showImgUrl:'',
            searchlist: {
                // applyName: "",
                // approvalStatus: "",
                // time: []
            },
            tableData: [],
            tableDataUrl: "",
            // 审核弹框显示隐藏
            examineDialogVisible: false,
            lookDialogVisible:false,
            // 重新赋值需要绑定
            examine: {
                approvalStatus: "",
                applyType: "",
                suggestion: ""
            },
            time: "",
            applyTypeList: [],
            rules: {
                suggestion: [
                    {
                        required: true,
                        message: "请输入审核不通过原因",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 100,
                        message: "长度在 1到 100 个字符",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        //显示大图
        show:function(url){
            this.showImg = true
            this.showImgUrl = url
        },
        // 操作=》审核
        async examineDialog(id) {
            this.examineDialogVisible = true;
            let res = await this.$http.post(
                "/admin/attendance/apply/info/get",
                {
                    id: id
                }
            );
            if (res.code !== 200) {
                this.$message.error("获取数据失败");
            }
            this.$message.success("获取数据成功");
            if(res.content.photo != null && res.content.photo != undefined){
                let list = res.content.photo.split(',')
                list.map((item, index) => {
                    if(item == ''){
                        list.splice(index, 1)
                    }
                })
                res.content.photo = list;
            }
            if(res.content.leaveTimeLength != null && res.content.leaveTimeLength != undefined){
                res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
            }

            // 判断请假类型
            const exValue = res.content.applyType;
            if (exValue == 1) {
               res.content.applyType = "事假";
            } else if (exValue == 2) {
                res.content.applyType = "病假";
            } else if (exValue == 3) {
                res.content.applyType = "调休";
            }

            // 判断状态类型
            const eaValue = res.content.approvalStatus;
            if (eaValue == 0) {
                res.content.approvalStatus = "待审核";
            } else if (eaValue == 1) {
                res.content.approvalStatus = "审核不通过";
            } else if (eaValue == 2) {
                res.content.approvalStatus = "审核通过";
            }
            this.examine = res.content
            this.getPageDatas('','leave')

            // this.getPageDatas();
        },
         async lookDialog(id) {
            this.lookDialogVisible = true;
            let res = await this.$http.post(
                "/admin/attendance/apply/info/get",
                {
                    id: id
                }
            );
            if (res.code !== 200) {
                this.$message.error("获取数据失败");
            }
            this.$message.success("获取数据成功");
            if(res.content.photo != null && res.content.photo != undefined){
                let list = res.content.photo.split(',')
                list.map((item, index) => {
                    if(item == ''){
                        list.splice(index, 1)
                    }
                })
                res.content.photo = list;
            }

            if(res.content.leaveTimeLength != null && res.content.leaveTimeLength != undefined){
                res.content.leaveTimeLength = (+res.content.leaveTimeLength).toFixed(2)
            }
            // 判断请假类型
            const exValue = res.content.applyType;
            if (exValue == 1) {
               res.content.applyType = "事假";
            } else if (exValue == 2) {
                res.content.applyType = "病假";
            } else if (exValue == 3) {
                res.content.applyType = "调休";
            }

            // 判断状态类型
            const eaValue = res.content.approvalStatus;
            if (eaValue == 0) {
                res.content.approvalStatus = "待审核";
            } else if (eaValue == 1) {
                res.content.approvalStatus = "审核不通过";
            } else if (eaValue == 2) {
                res.content.approvalStatus = "审核通过";
            }
            this.examine = res.content
            this.getPageDatas('','leave')
        },

        // 操作=》审核=》通过&&未通过
        // async shenhe(id, status) {
        //     let res = await this.$http.post(
        //         "/admin/attendance/apply/info/verify",
        //         {
        //             id: id,
        //             approvalStatus: status
        //         }
        //     );
        //     if (res.code !== 200) {
        //         this.$message.error("审批数据失败");
        //     }
        //     this.$message.success("审批数据成功");
        //     console.log(res);
        //     this.examineDialogVisible = false;
        //     this.getPageDatas();
        // },

        // 加上校验
        shenhe(id, status) {
           // console.log(this.$refs.shenHeJiaoYan);
            this.$refs.examineForm.validate(async valid => {
                if(status == 1){
                    if(this.examine.suggestion == ""){
                        this.$message.success("请输入审核不通过原因")
                        return
                    }
                }
                // if (!valid) return;
                let res = await this.$http.post(
                    "/admin/attendance/apply/info/verify",
                    {
                        id: id,
                        approvalStatus: status,
                        suggestion:this.examine.suggestion
                    }
                );
                if (res.code !== 200) {
                    this.$message.error("审批数据失败");
                }
                this.$message.success("审批数据成功");
                this.examineDialogVisible = false;
                this.examine.suggestion = ''
                this.getPageDatas('','leave')
            });
        },

        // 操作==》删除
        async deleteDialog(id) {
            const confirmResult = await this.$confirm(
                "此操作将永久删除该用户, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).catch(err => err);
            if (confirmResult !== "confirm") {
                return this.$message.info("已经取消删除");
            }
            let res = await this.$http.post(
                "/admin/attendance/apply/info/delete",
                { id: id }
            );
            console.log(res);
            if (res.code !== 200) {
                this.$message.error("删除数据失败");
            }
            this.$message.success("删除数据成功");
            this.getPageDatas('','leave');
        }
    },
    filters: {
        // 过滤请假类型
        applyTypeListFilter(value) {
            if (value == 1) {
                return "事假";
            } else if (value == 2) {
                return "病假";
            } else if (value == 3) {
                return "调休";
            }
        }
    },
    created() {
        // this.initTableDataUrl("/admin/attendance/apply/info/list", [1, 2, 3],'leave');
    },
    mounted() {
        // this.forList();
    }
};
</script>

<style scoped lang="less">
img.tbImg {
    width: 20px;
    height: 20px;
}

img.tbImgTwo {
    width: 150px;
    height: 150px;
    margin:0 10px 10px 0;
}
.shenhe{
    color:red;
    &:hover{
        color:skyblue;
    }
}
.bigbox{
    position: fixed;
    z-index: 99999999999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    .bigImg{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width:80%;
        max-height:90%;
    }
}
</style>
